module.exports = __webpack_public_path__ + "./assets/wahoo-d362db.obj";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wahoo.obj
// module id = 22
// module chunks = 0